document.documentElement.classList.remove('no-js');

document.querySelectorAll('[data-slider]').forEach((slider)=>{
  const track=slider.querySelector('[data-slider-track]');
  const prev=slider.querySelector('[data-prev]');
  const next=slider.querySelector('[data-next]');
  if(!track)return;

  const slides=[...track.children];
  const autoplay=slider.dataset.autoplay==='true' && slides.length>1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const autoplaySpeed=Math.max(2000,Number(slider.dataset.autoplaySpeed)||3000);
  let autoplayTimer=null;

  const currentIndex=()=>{
    if(!track.clientWidth)return 0;
    return Math.round(track.scrollLeft/track.clientWidth);
  };

  const goTo=(index)=>{
    if(!slides.length)return;
    const target=(index+slides.length)%slides.length;
    track.scrollTo({left:track.clientWidth*target,behavior:'smooth'});
  };

  const move=(dir)=>goTo(currentIndex()+dir);
  const stopAutoplay=()=>{
    if(autoplayTimer){
      window.clearInterval(autoplayTimer);
      autoplayTimer=null;
    }
  };
  const startAutoplay=()=>{
    if(!autoplay || document.hidden)return;
    stopAutoplay();
    autoplayTimer=window.setInterval(()=>move(1),autoplaySpeed);
  };
  const restartAutoplay=()=>{
    stopAutoplay();
    startAutoplay();
  };

  prev&&prev.addEventListener('click',()=>{
    move(-1);
    restartAutoplay();
  });
  next&&next.addEventListener('click',()=>{
    move(1);
    restartAutoplay();
  });

  slider.addEventListener('mouseenter',stopAutoplay);
  slider.addEventListener('mouseleave',startAutoplay);
  slider.addEventListener('focusin',stopAutoplay);
  slider.addEventListener('focusout',startAutoplay);
  track.addEventListener('touchstart',stopAutoplay,{passive:true});
  track.addEventListener('touchend',restartAutoplay,{passive:true});
  document.addEventListener('visibilitychange',()=>{
    if(document.hidden)stopAutoplay();
    else startAutoplay();
  });

  startAutoplay();
});

const headerNav=document.querySelector('[data-header-nav]');
if(headerNav && document.body.classList.contains('template-index')){
  const updateHeader=()=>headerNav.classList.toggle('is-scrolled',window.scrollY>120);
  updateHeader();
  window.addEventListener('scroll',updateHeader,{passive:true});
}

document.querySelectorAll('[data-mobile-menu-toggle]').forEach((toggle)=>{
  const menuId=toggle.getAttribute('aria-controls');
  const menu=menuId?document.getElementById(menuId):null;
  if(!menu)return;

  const setOpen=(open,returnFocus=true)=>{
    menu.setAttribute('aria-hidden',String(!open));
    toggle.setAttribute('aria-expanded',String(open));
    document.body.classList.toggle('mobile-menu-open',open);

    if(open){
      const first=menu.querySelector('[data-mobile-menu-close],a[href]');
      requestAnimationFrame(()=>first&&first.focus());
    }else if(returnFocus){
      toggle.focus();
    }
  };

  toggle.addEventListener('click',()=>{
    setOpen(toggle.getAttribute('aria-expanded')!=='true');
  });

  menu.querySelectorAll('[data-mobile-menu-close]').forEach((button)=>{
    button.addEventListener('click',()=>setOpen(false));
  });

  menu.querySelectorAll('a[href]').forEach((link)=>{
    link.addEventListener('click',()=>setOpen(false,false));
  });

  document.addEventListener('keydown',(event)=>{
    if(toggle.getAttribute('aria-expanded')!=='true')return;

    if(event.key==='Escape'){
      event.preventDefault();
      setOpen(false);
      return;
    }

    if(event.key==='Tab'){
      const focusable=[...menu.querySelectorAll('a[href],button:not([tabindex="-1"])')].filter((element)=>!element.disabled);
      if(!focusable.length)return;
      const first=focusable[0];
      const last=focusable[focusable.length-1];

      if(event.shiftKey && document.activeElement===first){
        event.preventDefault();
        last.focus();
      }else if(!event.shiftKey && document.activeElement===last){
        event.preventDefault();
        first.focus();
      }
    }
  });

  const desktopQuery=window.matchMedia('(min-width: 901px)');
  desktopQuery.addEventListener('change',(event)=>{
    if(event.matches && toggle.getAttribute('aria-expanded')==='true'){
      setOpen(false,false);
    }
  });
});

const initMinimalProduct=(root)=>{
  if(!root || root.dataset.minimalProductReady==='true')return;
  root.dataset.minimalProductReady='true';

  const currency=root.dataset.currency||'PKR';
  let cartTotal=Number(root.dataset.cartTotal||0);
  const form=root.querySelector('.mpx__form');
  const variantField=root.querySelector('[data-product-variant]');
  const quantityInput=form?.querySelector('input[name="quantity"]');
  const priceNode=root.querySelector('[data-product-price]');
  const compareNode=root.querySelector('[data-product-compare]');
  const saveBadge=root.querySelector('[data-save-badge]');
  const totalNode=root.querySelector('[data-checkout-total]');
  const statusNode=root.querySelector('[data-product-status]');
  const buyButtons=[...root.querySelectorAll('[data-buy-now],[data-sticky-buy-now]')];
  const addButton=root.querySelector('[data-add-cart]');

  const money=(cents)=>{
    try{
      return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(cents/100);
    }catch(error){
      return currency+' '+(cents/100).toFixed(2);
    }
  };

  const getVariant=()=>{
    if(!variantField)return {id:null,price:0,compare:0,available:false};
    if(variantField.tagName==='SELECT'){
      const option=variantField.selectedOptions[0];
      return {
        id:option?.value||null,
        price:Number(option?.dataset.price||0),
        compare:Number(option?.dataset.compare||0),
        available:option?.dataset.available==='true'
      };
    }
    return {
      id:variantField.value,
      price:Number(variantField.dataset.price||0),
      compare:Number(variantField.dataset.compare||0),
      available:variantField.dataset.available==='true'
    };
  };

  const getQuantity=()=>Math.max(1,Number(quantityInput?.value||1));

  const refreshUI=()=>{
    const variant=getVariant();
    const quantity=getQuantity();

    if(priceNode)priceNode.textContent=money(variant.price);

    if(compareNode){
      if(variant.compare>variant.price){
        compareNode.textContent=money(variant.compare);
        compareNode.classList.remove('is-hidden');
      }else{
        compareNode.textContent='';
        compareNode.classList.add('is-hidden');
      }
    }

    if(saveBadge){
      if(variant.compare>variant.price){
        saveBadge.textContent='Save '+money(variant.compare-variant.price);
        saveBadge.classList.remove('is-hidden');
      }else{
        saveBadge.textContent='';
        saveBadge.classList.add('is-hidden');
      }
    }

    if(totalNode)totalNode.textContent=money(cartTotal+(variant.price*quantity));

    buyButtons.forEach((button)=>{button.disabled=!variant.available;});
    if(addButton)addButton.disabled=!variant.available;
  };

  const galleryPanels=[...root.querySelectorAll('[data-gallery-panel]')];
  const galleryThumbs=[...root.querySelectorAll('[data-gallery-thumb]')];
  const galleryStage=root.querySelector('.mpx__stage');
  let galleryIndex=Math.max(0,galleryThumbs.findIndex((thumb)=>thumb.classList.contains('is-active')));

  const showGalleryIndex=(index)=>{
    if(!galleryPanels.length)return;
    const target=Math.max(0,Math.min(galleryPanels.length-1,index));
    galleryIndex=target;

    galleryPanels.forEach((panel,panelIndex)=>{
      panel.hidden=panelIndex!==target;
      panel.setAttribute('aria-hidden',String(panelIndex!==target));
    });

    galleryThumbs.forEach((thumb,thumbIndex)=>{
      const active=thumbIndex===target;
      thumb.classList.toggle('is-active',active);
      thumb.setAttribute('aria-pressed',String(active));
    });

    const activeThumb=galleryThumbs[target];
    const strip=activeThumb?.parentElement;
    if(activeThumb && strip){
      const left=activeThumb.offsetLeft-(strip.clientWidth-activeThumb.clientWidth)/2;
      strip.scrollTo({left:Math.max(0,left),behavior:'smooth'});
    }
  };

  galleryThumbs.forEach((thumb,index)=>{
    thumb.addEventListener('click',()=>showGalleryIndex(index));
  });

  if(galleryStage && galleryPanels.length>1){
    let startX=0;
    let startY=0;
    let tracking=false;

    galleryStage.addEventListener('touchstart',(event)=>{
      if(event.touches.length!==1)return;
      const touch=event.touches[0];
      startX=touch.clientX;
      startY=touch.clientY;
      tracking=true;
    },{passive:true});

    galleryStage.addEventListener('touchend',(event)=>{
      if(!tracking || !event.changedTouches.length)return;
      tracking=false;
      const touch=event.changedTouches[0];
      const dx=touch.clientX-startX;
      const dy=touch.clientY-startY;

      if(Math.abs(dx)<42 || Math.abs(dx)<=Math.abs(dy)*1.15)return;
      showGalleryIndex(galleryIndex+(dx<0?1:-1));
    },{passive:true});
  }

  root.querySelectorAll('[data-qty-control]').forEach((control)=>{
    const input=control.querySelector('input');
    control.querySelector('[data-qty-minus]')?.addEventListener('click',()=>{
      input.value=String(Math.max(1,(Number(input.value)||1)-1));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
    control.querySelector('[data-qty-plus]')?.addEventListener('click',()=>{
      input.value=String(Math.max(1,(Number(input.value)||1)+1));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    });
  });

  const addCurrentToCart=async()=>{
    const variant=getVariant();
    if(!variant.id || !variant.available)throw new Error('This option is unavailable.');
    const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:Number(variant.id),quantity:getQuantity()}]})
    });
    if(!response.ok){
      const data=await response.json().catch(()=>({}));
      throw new Error(data.description||'Could not add this item.');
    }
    return response.json();
  };

  const refreshCart=async()=>{
    const response=await fetch((window.Shopify?.routes?.root||'/')+'cart.js',{headers:{'Accept':'application/json'}});
    if(!response.ok)return;
    const cart=await response.json();
    cartTotal=Number(cart.total_price||0);
    root.dataset.cartTotal=String(cartTotal);
    refreshUI();
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart}}));
  };

  addButton?.addEventListener('click',async()=>{
    if(addButton.disabled)return;
    const original=addButton.textContent;
    addButton.disabled=true;
    if(statusNode)statusNode.textContent='';
    addButton.textContent='Adding…';
    try{
      await addCurrentToCart();
      await refreshCart();
      addButton.textContent='Added ✓';
      if(statusNode)statusNode.textContent='Added to cart.';
      window.setTimeout(()=>{addButton.textContent=original;refreshUI();},1300);
    }catch(error){
      addButton.textContent=original;
      if(statusNode)statusNode.textContent=error.message||'Could not add this item.';
      refreshUI();
    }
  });

  const buyNow=async(button)=>{
    if(button.disabled)return;
    const original=button.textContent;
    buyButtons.forEach((item)=>item.disabled=true);
    button.textContent='Opening checkout…';
    if(statusNode)statusNode.textContent='';
    try{
      await addCurrentToCart();
      window.location.assign((window.Shopify?.routes?.root||'/')+'checkout');
    }catch(error){
      button.textContent=original;
      if(statusNode)statusNode.textContent=error.message||'Could not start checkout.';
      refreshUI();
    }
  };

  buyButtons.forEach((button)=>button.addEventListener('click',()=>buyNow(button)));

  variantField?.addEventListener('change',refreshUI);
  quantityInput?.addEventListener('change',refreshUI);
  quantityInput?.addEventListener('input',refreshUI);

  root.querySelectorAll('[data-product-countdown]').forEach((countdown)=>{
    const output=countdown.querySelector('[data-countdown-value]');
    const end=Date.parse(countdown.dataset.end||'');
    if(!output || Number.isNaN(end))return;

    const render=()=>{
      const remaining=end-Date.now();
      if(remaining<=0){
        output.textContent='Ended';
        return false;
      }
      const total=Math.floor(remaining/1000);
      const days=Math.floor(total/86400);
      const hours=Math.floor((total%86400)/3600);
      const minutes=Math.floor((total%3600)/60);
      const seconds=total%60;
      const clock=[hours,minutes,seconds].map((value)=>String(value).padStart(2,'0')).join(':');
      output.textContent=days>0?days+'d '+clock:clock;
      return true;
    };

    render();
    const timer=window.setInterval(()=>{
      if(!render())window.clearInterval(timer);
    },1000);
  });

  refreshUI();
};

document.querySelectorAll('[data-minimal-product]').forEach(initMinimalProduct);
document.addEventListener('shopify:section:load',(event)=>{
  const root=event.target.matches?.('[data-minimal-product]')?event.target:event.target.querySelector?.('[data-minimal-product]');
  initMinimalProduct(root);
});

const initRelatedProducts=(root)=>{
  if(!root || root.dataset.relatedReady==='true')return;
  root.dataset.relatedReady='true';
  const url=root.dataset.url;
  if(!url)return;

  const load=async()=>{
    try{
      const response=await fetch(url,{headers:{'Accept':'text/html'}});
      if(!response.ok)return;
      const html=document.createElement('div');
      html.innerHTML=await response.text();
      const replacement=html.querySelector('[data-related-products]');
      if(replacement && replacement.innerHTML.trim()){
        root.innerHTML=replacement.innerHTML;
      }
    }catch(error){}
  };

  if('IntersectionObserver' in window){
    const observer=new IntersectionObserver((entries)=>{
      if(!entries[0].isIntersecting)return;
      observer.disconnect();
      load();
    },{rootMargin:'0px 0px 240px 0px'});
    observer.observe(root);
  }else{
    load();
  }
};

document.querySelectorAll('[data-related-products]').forEach(initRelatedProducts);
document.addEventListener('shopify:section:load',(event)=>{
  const root=event.target.matches?.('[data-related-products]')?event.target:event.target.querySelector?.('[data-related-products]');
  initRelatedProducts(root);
});

const initScrollReveal=()=>{
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;

  const items=[...document.querySelectorAll('#MainContent > .shopify-section')]
    .filter((item)=>!item.querySelector('.mpx__sticky'));

  if(!items.length)return;

  if(!('IntersectionObserver' in window)){
    items.forEach((item)=>item.classList.add('is-visible'));
    return;
  }

  const observer=new IntersectionObserver((entries)=>{
    entries.forEach((entry)=>{
      if(!entry.isIntersecting)return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  },{threshold:.08,rootMargin:'0px 0px -5% 0px'});

  items.forEach((item,index)=>{
    item.classList.add('bt-scroll-reveal');
    item.style.transitionDelay=Math.min(index,2)*55+'ms';
    observer.observe(item);
  });
};

initScrollReveal();
document.addEventListener('shopify:section:load',(event)=>{
  const section=event.target.closest?.('.shopify-section')||event.target;
  if(!section || section.querySelector?.('.mpx__sticky'))return;
  section.classList.add('bt-scroll-reveal');
  requestAnimationFrame(()=>section.classList.add('is-visible'));
});
